/* assets/cap-configurator.js — 3D Film Parts cap configurator (bundles).
   Variants = bundle sizes. Pick a bundle -> price + how many caps (N). For N>1: same design on
   all, or a different design per cap (per-cap upload slots, active cap shown in the 3D preview).
   Graphic is composited onto the current cap colour so transparency shows the cap surface, not black. */
(function () {
  const root = document.querySelector('[data-dfp-cap]');
  if (!root) return;
  const $ = s => root.querySelector(s);
  const mv = $('[data-viewer]');
  const dropEl = $('[data-drop]');
  const fileEl = $('[data-file]');
  const errEl = $('[data-err]'); const errMsg = $('[data-errmsg]');
  const toggleEl = $('[data-toggle]'); const switchEl = $('[data-switch]');
  const sizeEl = $('[data-size]');
  const coloursEl = $('[data-colours]');
  const bundlesEl = $('[data-bundles]'); const bundleNoteEl = $('[data-bundlenote]');
  const percapEl = $('[data-percap]'); const slotsEl = $('[data-slots]');
  const addBtn = $('[data-add]'); const resetBtn = $('[data-reset]');
  const emptyEl = $('[data-empty]'); const applyingEl = $('[data-applying]'); const capBadge = $('[data-capbadge]');
  const nameWrap = $('[data-namewrap]'); const nameEl = $('[data-name]'); const thumbEl = $('[data-thumb]');
  const priceEl = $('[data-price]'); const priceMetaEl = $('[data-pricemeta]');

  const ENDPOINT = root.dataset.endpoint;
  const MAXMB = parseFloat(root.dataset.maxmb) || 30;
  const METANOTE = root.dataset.madetoorder || 'MADE TO ORDER';
  const COLOURS = { Black: '#1A1917', White: '#F2EFE8' };

  const variants = JSON.parse(document.querySelector('[data-cap-variants]').textContent).map(v => ({
    id: String(v.id), title: v.title, price: v.price, n: parseInt((String(v.title).match(/\d+/) || [1])[0], 10) || 1
  }));
  let selBundle = 0;
  const N = () => variants[selBundle].n;

  let colour = 'Black', capHex = COLOURS.Black, removeBg = true, graphicScale = 0.82;
  let perCap = false, activeCap = 0, caps = [], busy = false, sizeRaf = 0, pickIndex = 0;

  const showErr = m => { if (m) errMsg.textContent = m; errEl.hidden = !m; };
  const slotsMode = () => N() > 1 && perCap;

  // ---- bundle selector ----
  bundlesEl.addEventListener('click', e => { const b = e.target.closest('[data-bundle]'); if (!b) return; selectBundle([...bundlesEl.children].indexOf(b)); });
  function selectBundle(i) {
    selBundle = i;
    bundlesEl.querySelectorAll('.dfp-cap__bundle').forEach((b, idx) => b.classList.toggle('is-on', idx === i));
    priceEl.textContent = variants[i].price;
    priceMetaEl.textContent = variants[i].title.toUpperCase() + ' · ' + METANOTE;
    percapEl.hidden = N() <= 1;
    bundleNoteEl.hidden = !(N() > 1 && !perCap);
    caps.length = N();
    if (activeCap >= N()) activeCap = 0;
    updateGraphicUI();
    renderFace();
  }

  // ---- same / different ----
  percapEl.addEventListener('click', e => {
    const b = e.target.closest('[data-mode]'); if (!b) return;
    perCap = b.dataset.mode === 'diff';
    percapEl.querySelectorAll('button').forEach(x => x.classList.toggle('is-on', x === b));
    bundleNoteEl.hidden = !(N() > 1 && !perCap);
    activeCap = 0;
    updateGraphicUI();
    renderFace();
  });

  function updateGraphicUI() {
    const sm = slotsMode();
    slotsEl.hidden = !sm;
    dropEl.hidden = sm;
    capBadge.hidden = !sm;
    if (sm) buildSlots();
    updateBadge();
  }

  function buildSlots() {
    slotsEl.innerHTML = '';
    for (let i = 0; i < N(); i++) {
      const cap = caps[i];
      const slot = document.createElement('div');
      slot.className = 'dfp-cap__slot' + (i === activeCap ? ' is-active' : '');
      const bg = (cap && cap.url) ? 'background-image:url(' + cap.url + ')' : '';
      slot.innerHTML = '<div class="dfp-cap__slotthumb" style="' + bg + '">' + ((cap && cap.url) ? '' : '+') + '</div><span class="dfp-cap__slotlbl">CAP ' + (i + 1) + '</span>';
      slot.addEventListener('click', () => {
        if (caps[i] && caps[i].img) { activeCap = i; markActive(); updateBadge(); renderFace(); }
        else { pickIndex = i; fileEl.click(); }
      });
      slotsEl.appendChild(slot);
    }
  }
  function markActive() { slotsEl.querySelectorAll('.dfp-cap__slot').forEach((s, i) => s.classList.toggle('is-active', i === activeCap)); }
  function refreshSlot(i) { const s = slotsEl.children[i]; if (!s) return; const t = s.querySelector('.dfp-cap__slotthumb'); const cap = caps[i];
    if (cap && cap.url) { t.style.backgroundImage = 'url(' + cap.url + ')'; t.textContent = ''; } else { t.style.backgroundImage = ''; t.textContent = '+'; } }
  function updateBadge() { if (!capBadge.hidden) capBadge.textContent = 'CAP ' + (activeCap + 1); }

  // ---- colour ----
  coloursEl.addEventListener('click', e => { const b = e.target.closest('[data-colour]'); if (!b) return;
    coloursEl.querySelectorAll('.dfp-cap__col').forEach(x => x.classList.remove('is-on')); b.classList.add('is-on');
    colour = b.dataset.colour; capHex = b.dataset.hex; setBody(capHex); renderFace(); refreshThumbs(); });
  async function setBody(hex) { await mv.updateComplete; const m = mv.model && mv.model.materials.find(x => x.name === 'CapBody'); if (m) m.pbrMetallicRoughness.setBaseColorFactor(hexRgb(hex)); }
  function hexRgb(h) { return [parseInt(h.slice(1, 3), 16) / 255, parseInt(h.slice(3, 5), 16) / 255, parseInt(h.slice(5, 7), 16) / 255, 1]; }

  // ---- upload ----
  dropEl.addEventListener('click', () => { pickIndex = 0; fileEl.click(); });
  fileEl.addEventListener('change', () => { const f = fileEl.files[0]; if (f) handleFile(f, slotsMode() ? pickIndex : 0); fileEl.value = ''; });
  ['dragenter', 'dragover'].forEach(ev => dropEl.addEventListener(ev, e => { e.preventDefault(); dropEl.classList.add('is-drag'); }));
  ['dragleave', 'drop'].forEach(ev => dropEl.addEventListener(ev, e => { e.preventDefault(); dropEl.classList.remove('is-drag'); }));
  dropEl.addEventListener('drop', e => { const f = e.dataTransfer.files[0]; if (f) handleFile(f, 0); });

  async function handleFile(f, idx) {
    showErr(false);
    const ok = /\.(png|jpe?g|webp|gif|svg|bmp|avif)$/i.test(f.name) || (f.type && f.type.indexOf('image/') === 0);
    if (!ok) { showErr("That file won't work. Use an image (JPG, PNG, SVG) under " + MAXMB + "MB."); return; }
    if (f.size > MAXMB * 1024 * 1024) { showErr('That file is over ' + MAXMB + 'MB. Use an image under ' + MAXMB + 'MB.'); return; }
    const img = new Image();
    img.onload = async () => {
      caps[idx] = { img: img, logoCanvas: null, url: null };
      if (!nameEl.value) nameEl.value = f.name.replace(/\.[a-z0-9]+$/i, '').slice(0, 40);
      applyingEl.hidden = false; await new Promise(r => setTimeout(r, 60));
      prepLogo(idx); activeCap = idx;
      await renderFace();
      emptyEl.style.display = 'none'; resetBtn.hidden = false; nameWrap.hidden = false;
      if (slotsMode()) { refreshSlot(idx); markActive(); updateBadge(); }
      applyingEl.hidden = true;
    };
    img.onerror = () => showErr("That file won't work. Use an image (JPG, PNG, SVG) under " + MAXMB + "MB.");
    img.src = URL.createObjectURL(f);
  }

  toggleEl.addEventListener('click', () => { removeBg = !removeBg; switchEl.classList.toggle('is-on', removeBg); toggleEl.setAttribute('aria-pressed', String(removeBg));
    caps.forEach((c, i) => { if (c && c.img) prepLogo(i); }); renderFace(); refreshThumbs(); });

  sizeEl.addEventListener('input', () => { graphicScale = +sizeEl.value / 100; if (!sizeRaf) sizeRaf = requestAnimationFrame(() => { sizeRaf = 0; renderFace(); refreshThumbs(); }); });

  resetBtn.addEventListener('click', () => { caps = []; caps.length = N(); activeCap = 0; fileEl.value = ''; nameEl.value = ''; showErr(false);
    emptyEl.style.display = ''; resetBtn.hidden = true; nameWrap.hidden = true; if (slotsMode()) buildSlots(); renderFace(); });

  // ---- graphic processing ----
  function prepLogo(i) { const cap = caps[i]; if (!cap || !cap.img) { if (cap) cap.logoCanvas = null; return; }
    const img = cap.img, max = 1024, s = Math.min(1, max / Math.max(img.width, img.height));
    const cw = Math.max(1, Math.round(img.width * s)), ch = Math.max(1, Math.round(img.height * s));
    const cv = document.createElement('canvas'); cv.width = cw; cv.height = ch; const c = cv.getContext('2d');
    c.drawImage(img, 0, 0, cw, ch);
    if (removeBg && isMostlyOpaque(c, cw, ch)) removeBackground(c, cw, ch, 45);
    cap.logoCanvas = cv;
  }
  function isMostlyOpaque(ctx, W, H) { const d = ctx.getImageData(0, 0, W, H).data; let t = 0; for (let i = 3; i < d.length; i += 4) if (d[i] < 20) t++; return (t / (W * H)) < 0.02; }

  function composite(logoCanvas) {
    const S = 1024, cv = document.createElement('canvas'); cv.width = cv.height = S; const x = cv.getContext('2d');
    x.fillStyle = capHex; x.fillRect(0, 0, S, S);
    if (logoCanvas) { const sc = Math.min(S * graphicScale / logoCanvas.width, S * graphicScale / logoCanvas.height); const w = logoCanvas.width * sc, h = logoCanvas.height * sc; x.drawImage(logoCanvas, (S - w) / 2, (S - h) / 2, w, h); }
    return cv.toDataURL('image/png');
  }

  async function renderFace() {
    await mv.updateComplete; if (!mv.model) return;
    const src = slotsMode() ? caps[activeCap] : caps[0];
    const url = composite(src && src.logoCanvas ? src.logoCanvas : null);
    if (src && src.img) { src.url = url; if (thumbEl) thumbEl.src = url; }
    const tex = await mv.createTexture(url);
    const m = mv.model.materials.find(mm => mm.name === 'Graphic');
    if (m) { m.pbrMetallicRoughness.baseColorTexture.setTexture(tex); m.pbrMetallicRoughness.setBaseColorFactor([1, 1, 1, 1]); }
  }
  function refreshThumbs() {
    caps.forEach((c, i) => { if (c && c.logoCanvas) { c.url = composite(c.logoCanvas); if (slotsMode()) refreshSlot(i); } });
    const src = slotsMode() ? caps[activeCap] : caps[0]; if (src && src.url && thumbEl) thumbEl.src = src.url;
  }

  function removeBackground(ctx, W, H, tol) {
    const im = ctx.getImageData(0, 0, W, H), d = im.data;
    const corners = [[0, 0], [W - 1, 0], [0, H - 1], [W - 1, H - 1]];
    let r = 0, g = 0, b = 0, n = 0;
    for (const [x, y] of corners) { const p = (y * W + x) * 4; if (d[p + 3] > 10) { r += d[p]; g += d[p + 1]; b += d[p + 2]; n++; } }
    if (n === 0) return; r /= n; g /= n; b /= n;
    const tol2 = tol * tol, seen = new Uint8Array(W * H), stack = [];
    for (const [x, y] of corners) stack.push(y * W + x);
    while (stack.length) {
      const pi = stack.pop(); if (seen[pi]) continue; seen[pi] = 1;
      const p = pi * 4, dr = d[p] - r, dg = d[p + 1] - g, db = d[p + 2] - b;
      if (dr * dr + dg * dg + db * db > tol2) continue;
      d[p + 3] = 0;
      const x = pi % W, y = (pi - x) / W;
      if (x + 1 < W) stack.push(pi + 1); if (x > 0) stack.push(pi - 1);
      if (y + 1 < H) stack.push(pi + W); if (y > 0) stack.push(pi - W);
    }
    ctx.putImageData(im, 0, 0);
  }

  function init() { setBody(capHex); selectBundle(0); }
  if (mv.loaded) init(); else mv.addEventListener('load', init);

  // ---- add to cart ----
  addBtn.addEventListener('click', async () => {
    if (busy) return;
    const n = N();
    let list;
    if (slotsMode()) { list = caps.slice(0, n); if (list.some(c => !c || !c.url)) { showErr('Upload a graphic for each of the ' + n + ' caps, or switch to "Same on all".'); return; } }
    else { if (!caps[0] || !caps[0].url) { showErr('Upload your logo first to preview and print it.'); return; } list = [caps[0]]; }
    busy = true; addBtn.disabled = true; const label = addBtn.innerHTML; addBtn.textContent = 'ADDING...'; showErr(false);
    try {
      const designName = (nameEl.value || 'Cap design').trim();
      const links = [];
      for (let i = 0; i < list.length; i++) {
        const base64 = list[i].url.split(',')[1];
        const res = await fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify({ files: [{ filename: slug(designName) + '-' + (i + 1) + '-' + Date.now() + '.png', mimeType: 'image/png', data: base64 }], folder: 'Cap Graphics' }) });
        const out = await res.json(); const link = out && out.files && out.files[0] && out.files[0].url; if (!link) throw new Error('upload'); links.push(link);
      }
      const body = new FormData();
      body.append('id', variants[selBundle].id);
      body.append('quantity', '1');
      body.append('properties[Bundle]', variants[selBundle].title);
      body.append('properties[Design name]', designName);
      body.append('properties[Cap colour]', colour);
      body.append('properties[Size]', Math.round(graphicScale * 100) + '%');
      // underscore-prefixed = hidden from cart/checkout (customer never sees it), still on the order for fulfilment
      if (slotsMode()) { links.forEach((l, i) => body.append('properties[_Cap ' + (i + 1) + ' graphic]', l)); }
      else { body.append('properties[_Graphic file]', links[0]); if (n > 1) body.append('properties[Prints on]', 'all ' + n + ' caps'); }
      const add = await fetch('/cart/add.js', { method: 'POST', body }); if (!add.ok) throw new Error('cart');
      window.location.href = '/cart';
    } catch (e) { busy = false; addBtn.disabled = false; addBtn.innerHTML = label; showErr('Sorry, something went wrong adding to cart. Please try again.'); }
  });
  function slug(s) { return (s || 'cap-graphic').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40) || 'cap-graphic'; }
})();
